// SG USP row (sections/sg-usp-row.liquid): a horizontal slider like the announcement bar.
// The track (.sg-usp__list) scrolls one page at a time; a page is a grouped slide (desktop "Slides" layout)
// or a single message. Auto-advances every data-interval seconds and loops; arrows step back/forward.
// Runs only while CSS turns the slider on for the current screen size (--sg-usp-slider: 1).
// Pauses on hover, focus and touch; no auto-advance with reduced motion.
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var init = function (root) {
    if (root.dataset.sgUspReady) return;
    root.dataset.sgUspReady = 'true';
    var track = root.querySelector('.sg-usp__list');
    if (!track) return;
    var interval = (parseFloat(root.getAttribute('data-interval')) || 4) * 1000;
    var paused = false;

    var active = function () {
      return getComputedStyle(root).getPropertyValue('--sg-usp-slider').trim() === '1';
    };
    // Step one message at a time (CSS --sg-usp-step: item). Forward steps loop: once the slide ends,
    // the message that slid out moves to the end and the scroll position drops back by one step.
    var stepItem = function () {
      return getComputedStyle(root).getPropertyValue('--sg-usp-step').trim() === 'item';
    };
    var items = function () {
      return track.querySelectorAll(':scope > .sg-usp__slide > .sg-usp__item');
    };
    var goItem = function (dir) {
      var list = items();
      if (list.length < 2) return;
      var step = list[1].offsetLeft - list[0].offsetLeft;
      if (step <= 0 || track.scrollWidth - track.clientWidth <= 2) return;
      if (dir < 0) {
        track.scrollTo({ left: Math.max(0, track.scrollLeft - step), behavior: reduced ? 'auto' : 'smooth' });
        return;
      }
      track.scrollTo({ left: track.scrollLeft + step, behavior: reduced ? 'auto' : 'smooth' });
      clearTimeout(track._sgUspLoop);
      track._sgUspLoop = setTimeout(function () {
        var first = items()[0];
        var slides = track.querySelectorAll(':scope > .sg-usp__slide');
        if (!first || !slides.length) return;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        slides[slides.length - 1].appendChild(first);
        track.scrollLeft = Math.max(0, track.scrollLeft - step);
        track.style.scrollBehavior = '';
        track.style.scrollSnapType = '';
      }, 700);
    };
    var go = function (dir) {
      if (stepItem()) { goItem(dir); return; }
      var page = track.clientWidth;
      var max = track.scrollWidth - page;
      if (max <= 2) return;
      var target = track.scrollLeft + dir * page;
      if (target > max + 2) target = 0;
      if (target < -2) target = max;
      track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
    };

    var prev = root.querySelector('.sg-usp__arrow--prev');
    var next = root.querySelector('.sg-usp__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    root.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, interval); }, { passive: true });

    if (!reduced) {
      setInterval(function () {
        if (!paused && !document.hidden && active()) go(1);
      }, interval);
    }
  };

  // Loox column: open Loox's reviews popup (same call as the Gift Guide trust bar), waiting briefly if Loox is still loading
  var openLoox = function (tries) {
    var loox = window.LOOX;
    if (loox && loox.root && loox.clientId && typeof loox.openHCFloater === 'function') { loox.openHCFloater(); return; }
    if (tries > 0) setTimeout(function () { openLoox(tries - 1); }, 300);
  };
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-sg-loox-open]')) openLoox(10);
  });
  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.closest && event.target.closest('[data-sg-loox-open]')) {
      event.preventDefault();
      openLoox(10);
    }
  });

  // Phone marquee: stop while a finger or mouse is on the band (CSS :hover is unreliable on touch screens)
  var pauseMarquee = function (root, on) { root.classList.toggle('is-paused', on); };
  document.addEventListener('pointerenter', function (event) {
    var root = event.target.closest && event.target.closest('.sg-usp--mmotion-marquee, .sg-usp--dmotion-marquee');
    if (root && event.pointerType === 'mouse') pauseMarquee(root, true);
  }, true);
  document.addEventListener('pointerleave', function (event) {
    var root = event.target.matches && event.target.matches('.sg-usp--mmotion-marquee, .sg-usp--dmotion-marquee') ? event.target : null;
    if (root && event.pointerType === 'mouse') pauseMarquee(root, false);
  }, true);
  document.addEventListener('touchstart', function (event) {
    var root = event.target.closest && event.target.closest('.sg-usp--mmotion-marquee, .sg-usp--dmotion-marquee');
    if (!root) return;
    pauseMarquee(root, true);
    clearTimeout(root._sgUspResume);
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    var root = event.target.closest && event.target.closest('.sg-usp--mmotion-marquee, .sg-usp--dmotion-marquee');
    if (!root) return;
    root._sgUspResume = setTimeout(function () { pauseMarquee(root, false); }, 2500);
  }, { passive: true });

  var initAll = function () { document.querySelectorAll('[data-sg-usp]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
